import { Badge } from "./Badge";
import { colors } from "../lib/tokens";
import { TENANT_IDENTITY_FIELDS } from "@klubora/shared";

interface LegalIdentityPillProps {
  /** Os rótulos que faltam, vindos de `missingTenantIdentityFields`. */
  missing: string[];
}

/**
 * KLUB-185 — o estado do cadastro jurídico do clube, em uma pílula.
 *
 * CONTA, EM VEZ DE DIZER SÓ "INCOMPLETO". O operador precisa saber quantos
 * gestos faltam antes de abrir o formulário; "incompleto" o obriga a abrir para
 * descobrir se falta um campo ou cinco.
 *
 * UM COMPONENTE, TRÊS TELAS. A ficha, o modal e o wizard mostram o mesmo estado
 * — e nasceram com três implementações da mesma pílula, que é como duas delas
 * envelhecem dizendo coisas diferentes sobre o mesmo cadastro.
 */
export function LegalIdentityPill({ missing }: LegalIdentityPillProps) {
  const total = TENANT_IDENTITY_FIELDS.length;
  const complete = missing.length === 0;
  return (
    <Badge
      label={
        complete
          ? `${total} de ${total} preenchidos`
          : `${missing.length} ${missing.length === 1 ? "campo faltando" : "campos faltando"}`
      }
      color={complete ? colors.success : colors.warning}
      bg={complete ? colors.successSoft : colors.warningSoft}
    />
  );
}
